
import React from 'react';
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

interface CategoryButtonProps {
  label: string;
  className?: string;
  onClick?: () => void;
}

const CategoryButton: React.FC<CategoryButtonProps> = ({ label, className, onClick }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <Button 
        variant="outline" 
        className={cn(
          "code-button min-w-[140px] h-8 px-4",
          "flex items-center justify-center text-sm",
          className
        )}
        onClick={onClick}
      >
        {label}
      </Button>
    </motion.div>
  );
};

export default CategoryButton;
